import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 22.08C17.5671 22.08 22.08 17.5671 22.08 12C22.08 6.43301 17.5671 1.92004 12 1.92004C6.43301 1.92004 1.92004 6.43301 1.92004 12C1.92004 17.5671 6.43301 22.08 12 22.08ZM12 17.04C14.7836 17.04 17.04 14.7836 17.04 12C17.04 9.21653 14.7836 6.96004 12 6.96004C9.21653 6.96004 6.96004 9.21653 6.96004 12C6.96004 14.7836 9.21653 17.04 12 17.04Z",
      fill: "#012879"
    }, null, -1)
  ]))]))
}
export default { render: render }